module.exports = __webpack_public_path__ + "static/2011-cranes-1b3742d5dc39f2c1b238477e4f1ca309.jpg";